import React from "react";

const PartnerEventsList = () => {
  return <div>PartnerEventsList</div>;
};

export default PartnerEventsList;
